/*
 * Cross-sell du tiroir panier — NOCCA
 *
 * Ajoute le produit proposé au panier sans recharger la page, puis
 * demande à Shopify le HTML à jour du tiroir et de la pastille panier.
 *
 * Les écouteurs sont posés sur `document` (délégation) : le contenu du
 * tiroir est remplacé à chaque mise à jour du panier, des écouteurs
 * attachés directement aux boutons seraient perdus.
 */
(function () {
  if (window.__noccaCartUpsellReady) return;
  window.__noccaCartUpsellReady = true;

  var ROOT_SELECTOR = '[data-cart-upsell]';
  var FALLBACK_ERROR = "L'ajout au panier a échoué. Réessaie dans un instant.";

  function getQuantityInput(container) {
    return container.querySelector('[data-cart-upsell-qty]');
  }

  function clampQuantity(input, value) {
    var min = parseInt(input.getAttribute('min'), 10);
    var max = parseInt(input.getAttribute('max'), 10);
    var next = value;

    if (isNaN(min)) min = 1;
    if (isNaN(next)) next = min;
    if (next < min) next = min;
    if (!isNaN(max) && next > max) next = max;

    return next;
  }

  function syncStepButtons(container) {
    var input = getQuantityInput(container);
    if (!input) return;

    var value = parseInt(input.value, 10);
    var min = parseInt(input.getAttribute('min'), 10);
    var max = parseInt(input.getAttribute('max'), 10);

    if (isNaN(min)) min = 1;

    container.querySelectorAll('[data-cart-upsell-step]').forEach(function (button) {
      var step = parseInt(button.getAttribute('data-cart-upsell-step'), 10);
      if (step < 0) {
        button.disabled = value <= min;
      } else {
        button.disabled = !isNaN(max) && value >= max;
      }
    });
  }

  function setLoading(container, isLoading) {
    container.classList.toggle('is-loading', isLoading);
    var button = container.querySelector('[data-cart-upsell-add]');
    if (button) button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function showError(container, message) {
    var target = container.querySelector('[data-cart-upsell-error]');
    if (!target) return;
    target.textContent = message;
    target.hidden = false;
  }

  function hideError(container) {
    var target = container.querySelector('[data-cart-upsell-error]');
    if (!target) return;
    target.textContent = '';
    target.hidden = true;
  }

  function getSectionIds(drawer) {
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function addToCart(container) {
    var button = container.querySelector('[data-cart-upsell-add]');
    if (!button || container.classList.contains('is-loading')) return;

    var variantId = parseInt(button.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    var input = getQuantityInput(container);
    var quantity = input ? clampQuantity(input, parseInt(input.value, 10)) : 1;

    var drawer = document.querySelector('cart-drawer');
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    hideError(container);
    setLoading(container, true);

    fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantity }],
        sections: getSectionIds(drawer).join(','),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        // Shopify renvoie un `status` seulement en cas d'erreur (rupture, etc.).
        if (data.status) {
          setLoading(container, false);
          showError(container, data.description || data.message || FALLBACK_ERROR);
          return;
        }

        if (drawer && data.sections) {
          // Remplace le contenu du tiroir : `container` est retiré du DOM ici.
          drawer.renderContents(data);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        setLoading(container, false);
        showError(container, FALLBACK_ERROR);
      });
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var stepButton = event.target.closest('[data-cart-upsell-step]');
    if (stepButton) {
      var stepContainer = stepButton.closest(ROOT_SELECTOR);
      var input = stepContainer && getQuantityInput(stepContainer);
      if (!input) return;

      var step = parseInt(stepButton.getAttribute('data-cart-upsell-step'), 10) || 0;
      input.value = clampQuantity(input, (parseInt(input.value, 10) || 0) + step);
      syncStepButtons(stepContainer);
      return;
    }

    var addButton = event.target.closest('[data-cart-upsell-add]');
    if (addButton) {
      event.preventDefault();
      addToCart(addButton.closest(ROOT_SELECTOR));
    }
  });

  document.addEventListener('change', function (event) {
    if (!(event.target instanceof Element)) return;
    if (!event.target.matches('[data-cart-upsell-qty]')) return;

    var container = event.target.closest(ROOT_SELECTOR);
    event.target.value = clampQuantity(event.target, parseInt(event.target.value, 10));
    if (container) syncStepButtons(container);
  });

  // Le tiroir est réécrit à chaque mise à jour du panier : on resynchronise
  // l'état des boutons +/− dès qu'un nouveau bloc apparaît.
  function syncAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(syncStepButtons);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  var drawerNode = document.getElementById('CartDrawer');
  if (drawerNode && window.MutationObserver) {
    new MutationObserver(syncAll).observe(drawerNode, { childList: true, subtree: true });
  }
})();
